import { useState } from 'react';

/**
 * Custom hook for managing highlighting and coordination between panels
 * Extracts highlighting logic from the main component
 */
export function useHighlighting() {
  const [activeSection, setActiveSection] = useState(null);

  // Scroll and highlight helper function
  const scrollAndHighlight = (element) => {
    // Scroll to element
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    });

    // Store original styles before highlighting
    const originalBackgroundColor = element.style.backgroundColor;
    const originalBoxShadow = element.style.boxShadow;
    const originalTransition = element.style.transition;

    // Add highlight effect
    element.style.transition =
      'background-color 0.3s ease, box-shadow 0.3s ease';
    element.style.backgroundColor = '#fff3cd';
    element.style.boxShadow = '0 0 10px rgba(255, 193, 7, 0.5)';

    // Remove highlight after 1.5 seconds and restore original styles
    setTimeout(() => {
      element.style.backgroundColor = originalBackgroundColor;
      element.style.boxShadow = originalBoxShadow;
      element.style.transition = originalTransition;
    }, 1500);
  };

  // Expand accordion if needed and then highlight
  const expandAndHighlight = (element) => {
    const accordion = element.closest('.MuiAccordion-root');
    if (accordion && !accordion.classList.contains('Mui-expanded')) {
      const expandButton = accordion.querySelector('.MuiAccordionSummary-root');
      if (expandButton) {
        expandButton.click();
        // Wait for accordion to expand before scrolling and highlighting
        setTimeout(() => {
          scrollAndHighlight(element);
        }, 300);
        return;
      }
    }
    scrollAndHighlight(element);
  };

  // Highlighting coordination functions
  const highlightItemInRightPanel = (itemId) => {
    const rightElement = document.getElementById(`right-item-${itemId}`);
    if (rightElement) {
      expandAndHighlight(rightElement);
    }
  };

  const highlightItemInLeftPanel = (itemId) => {
    const leftElement = document.getElementById(`left-item-${itemId}`);
    if (leftElement) {
      expandAndHighlight(leftElement);
    }
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth',
      });
      setActiveSection(sectionId);
      section.classList.add('active');

      setTimeout(() => {
        section.classList.remove('active');
      }, 2000);
    }
  };

  return {
    activeSection,
    setActiveSection,
    highlightItemInRightPanel,
    highlightItemInLeftPanel,
    scrollToSection,
    scrollAndHighlight,
  };
}
